<template>
    <div>
        <p class="label" v-if="!hideLabel">{{ label }}</p>
        <MultiplePickerGroupInput
                :value="value"
                @input="onInput"
                :items="items"
                :loading="loading"
                v-bind="$attrs"
        />
    </div>
</template>

<script>
  import MultiplePickerGroupInput from '@/components/inputs/MultiplePickerGroupInput.vue';
  import SpecialityService from '@/services/speciality.service.js';

  export default {
    name: "SpecialityMultiplePickerInput",
    components: {
      MultiplePickerGroupInput,
    },
    props: {
      value: { type: Array, default: () => []},
      label: { type: String, default: 'Spécialité(s) envisagée(s) à poursuivre des études ?'},
      hideLabel: {type: Boolean, default: false},
      degreeTypeId: Number,
      taskEdit: { type: Boolean, default: false }
    },
    data() {
      return {
        items: [],
        loading: false,
        timeoutHandler: null,
      }
    },
    methods: {
      loadListItem() {
        if (this.loading) return;

        this.loading = true;

        const _this = this;
        SpecialityService.getList(this.degreeTypeId)
          .then(({data}) => {
            data.forEach((group) => {
              // Push header
              let parent = {
                name: group.name,
                id: [],
                level: 0
              }
              let children = [];

              // Push items
              group.children.forEach((item) => {
                parent.id.push(item.id);
                children.push({...item, level: 1});
              });
              _this.items.push(parent);
              _this.items = _this.items.concat(children);
            });
          })
          .finally(() => {
            _this.loading = false;
          })
      },
      onInput(event) {
        this.$emit('input', event);
      }
    },
    watch: {
      degreeTypeId: {
        immediate: true,
        handler(value) {
          const _this = this;
          this.items = [];
          
          //check task edit 
          if(!this.taskEdit){
            this.$emit('input', []);
          }else{
            this.$emit('resetTask', false);
          }          

          if (value) {
            clearTimeout(this.timeoutHandler);
            this.timeoutHandler = setTimeout(() => {
              _this.loadListItem();
            }, 1000);
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
